import {
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
    computed,
    DestroyRef,
    inject,
} from '@angular/core';
import { MessageBalanceService } from '@shared/services/message-balance.service';
import { MenuItem, MessageService } from 'primeng/api';
import { LayoutService } from '../app.layout.service';
import { NgClass } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { SharedPrimeNgModule } from '@shared/modules/shared-prime-ng.module';
import { AuthService } from '@core/auth/services/auth.service';
import { FirebaseAuthProvider } from '@shared/modules/auth/providers/firebase';
import { LoaderStoreService } from '@shared/services/loader-store.service';
import { UserService } from '@shared/modules/auth/services/user.service';
import { ChatsService } from '@shared/services/chats.service';
import { WSP_DISCONNECTED_TEXT, WspStatusService } from '@shared/services/wsp-status.service';
import { SUPPORT_WSP_DISPLAY, supportWspLink } from '@shared/constants/support';
import { Notification, NotificationService } from '@shared/services/messages/notification.service';
import { Observable, firstValueFrom } from 'rxjs';
import { ToastModule } from 'primeng/toast';
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    standalone: true,
    imports: [RouterLink, NgClass, SharedPrimeNgModule,ToastModule],
})
export class AppTopBarComponent implements OnInit {
    items!: MenuItem[];

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    itemsMenu: MenuItem[] = [];
    notifications: MenuItem[] = [];
    showGreen: boolean = false;
    currentUser : any;
    notificationsService = inject(NotificationService);
    authService = inject(AuthService);
    router = inject(Router);
    authProvider = inject(FirebaseAuthProvider);
    loaderStore = inject(LoaderStoreService);
         userService = inject(UserService);
         chatService = inject(ChatsService);
    //estado real de la conexión de WhatsApp (AF327): botón, mensaje al tocar "Desconectado" y revisiones automáticas
    wspStatus = inject(WspStatusService);
    private destroyRef = inject(DestroyRef);
    showWspDialog: boolean = false;
    wspDisconnectedText = WSP_DISCONNECTED_TEXT;
    supportDisplay = SUPPORT_WSP_DISPLAY;
    supportLink = supportWspLink('Hola, mi WhatsApp de AdminAI está desconectado');
    
    user$: any;
    messageService = inject(MessageService);

    //saldo en vivo: se actualiza solo cuando el backend modifica el mapa messageBalance
    messageBalance = inject(MessageBalanceService);
    isAdministration = this.messageBalance.isAdministration;
    availableMessages = this.messageBalance.availableMessages;
    messageBalanceStatus = this.messageBalance.status;
    availableMessagesText = computed(() => {
        const available = this.availableMessages();
        return `${available.toLocaleString('es-AR')} ${available === 1 ? 'mensaje' : 'mensajes'}`;
    });
    messagesTitle = computed(() => {
        switch (this.messageBalanceStatus()) {
            case 'empty':
                return 'Te quedaste sin mensajes: no podés enviar mensajes y el agente no responde por WhatsApp. Hacé click para comprar más';
            case 'low':
                return 'Te quedan pocos mensajes. Hacé click para comprar más';
            default:
                return 'Mensajes disponibles. Hacé click para comprar más';
        }
    });

    public layoutService = inject(LayoutService);

   async ngOnInit() {
        this.itemsMenu = [
            // {
            //     label: 'Account',
            //     icon: 'pi pi-user',
            // },
            {
                label: 'Configuración',
                icon: 'pi pi-cog',
                command: () => this.router.navigate(['/account/config']),
            },
            {
                label: 'Cerrar sesión',
                icon: 'pi pi-sign-out',
                command: () => this.logout(),
            },
        ];
        this.loaderStore .set('loading', true);
        try {
         
           //traer notificaciones
           this.currentUser = await this.userService.getCurrentUser();

           //revisiones del estado de WhatsApp (al entrar, al cambiar de pantalla y cada 15 minutos con la pestaña a la vista).
           //Antes el botón decía "Conectado" para toda cuenta con YCloud sin consultar nada
           this.wspStatus.start(this.destroyRef);

             

           let userNotifications =  await firstValueFrom(this.notificationsService.getAllnewNotifications(this.currentUser.parentUid,this.currentUser.uid));
            if(userNotifications.length === 0){
                this.notifications = [{label: 'No hay Notificaciones', icon: 'pi pi-bell-slash'}];
            }
            else{
                this.showGreen = true;
                this.notifications = userNotifications.map((notification: any) => ({
                    label: notification.title + ' - ' + notification.content,
                    icon: 'pi pi-bell',
                    command: () => {
                        this.resolveNotification(notification);
                    },
                    uid: notification.uid, // Agregar el UID de la notificación para identificarla
                }));
                this.notifications.unshift({label: 'Borrar Todas',styleClass:'borrar-btn' ,icon: 'pi pi-eraser', command: () => this.MarkAllAsRead(userNotifications)});
            }
        } catch (error) {
            
        }finally{
            
            this.loaderStore .set('loading', false);
        }
    }

    async resolveNotification(notification: Notification){
        try{
            this.loaderStore.set('loading', true);  
        await this.notificationsService.updateRead(this.currentUser.parentUid, this.currentUser.uid, notification.uid);
            this.messageService.add({
            severity: 'info',
            summary: 'Notificación',
            detail: 'La notificación ha sido marcada como leída.',
            });
            if(notification.data.url){
                this.router.navigateByUrl(notification.data.url);
            }
            this.notifications = this.notifications.filter((n: any) => n.uid !== notification.uid); // Eliminar la notificación de la lista
            if(this.notifications.length === 1 && this.notifications[0].label === 'Borrar Todas'){
                this.showGreen = false;
                this.notifications = [{label: 'No hay Notificaciones', icon: 'pi pi-bell-slash'}];
            }
        }catch(error){
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo resolver la notificación.',
              });
        }finally{
            this.loaderStore.set('loading', false);  
        }
    }
    async MarkAllAsRead(notifications: Notification[]){
        this.loaderStore.set('loading', true);
        try {
            await this.notificationsService.updateAllRead(this.currentUser.parentUid, this.currentUser.uid, notifications);
            this.messageService.add({
                severity: 'success',
                summary: 'Notificaciones',
                detail: 'Todas las notificaciones han sido marcadas como leídas.',
              });
            this.showGreen = false;
            this.notifications = [{label: 'No hay Notificaciones', icon: 'pi pi-bell-slash'}];
        }catch(error){
            this.messageService.add({
                severity: 'error',  
                summary: 'Error',
                detail: 'No se pudieron marcar las notificaciones como leídas.',
              });
        } finally {
            this.loaderStore.set('loading', false);
        }
    }

    async logout() {
        this.authService.provider = this.authProvider;
        await this.authProvider.logout();
        this.router.navigate(['/auth/login']);
    }

    goToUpgradePlan(){
           this.showWspDialog = false;
            this.router.navigate(['/subscription', this.currentUser.parentUid], { queryParams: { email: this.currentUser.email } });
    }

    goToChats(){
        this.router.navigate(['/chats']);
    }

    goToMessagePackages(){
        this.router.navigate(['/message-packages']);
    }
 
}
